module.exports = __webpack_public_path__ + "img/00-IngeSE-01.a9e4145c.png";